import { useSelector } from 'react-redux';
import { isRpaVerificationFailed } from '../../other/AddOnsHelperFunctions';
import { useHistory } from 'react-router-dom';
import Alert from '../../../../../itrust_common/components/Alert';
import * as $ from 'jquery';

function useInsuranceMappedFailed(selectedInsuranceName) {
  const services = useSelector((state) => state.visionInsurance.services);
  const visionInsuranceConfig = useSelector((state) => state.organisation.organisation.add_ons_config?.type?.vision_insurance)
  const rpaVerificationFailed = isRpaVerificationFailed(visionInsuranceConfig, services, selectedInsuranceName)
  const currentUserRole = useSelector((state) => state.auth.user?.role)
  const history = useHistory()

  const insuranceVerificationFailed = () => {
    if (['super_admin', 'itrust_admin'].includes(currentUserRole)) {
      Alert.confirm(<div>
        Insurance mapping was unsuccessful:<strong> {rpaVerificationFailed}</strong><br />
        Go to the setting and update the configuration for successful insurance verification.
      </div>,
        (res) => {
          if (res) {
            $('#orderForm-modal').modal('hide');
            history.push('/add-ons/vision-insurance/settings')
          }
        }
      )
    }
    else {
      Alert.warning(<div>
        Insurance mapping was unsuccessful:<strong> {rpaVerificationFailed}</strong><br />
        Please contact you super admin to update the configuration for successful insurance verification.
      </div>)
    }
  }
  return { rpaVerificationFailed, insuranceVerificationFailed }
}

export default useInsuranceMappedFailed;